import { NextQuery } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_MUTATIONS_KEYS } from '../query-signals.const';
import { QuerySignalsMutation } from '../query-signals.interfaces';

interface UpdateNextQueryMutationPayload {
  newFields: Partial<NextQuery>;
  nextQuery: NextQuery;
}

export class UpdateNextQueryMutation implements QuerySignalsMutation {
  mutations = {
    [QUERY_SIGNALS_MUTATIONS_KEYS.updateNextQuery]: (localState: QuerySignalsState,
      { newFields, nextQuery }: UpdateNextQueryMutationPayload) => {
      if (nextQuery) {
        Object.assign(nextQuery, newFields);
      }
    }
  };
}
